import { useHistory } from 'react-router-dom'

import { PreviewPix } from './PreviewPix'
import { PreviewFrame } from './PreviewFrame'
import { PreviewCrypto } from './PreviewCrypto'
import { PreviewMessage } from './PreviewMessage'

import { isProduction } from '../../settings'
import { PreviewBankwire } from './PreviewBankwire'
import { isMobileDevice, redirectToExternalUrl } from 'mmfintech-commons'
import { useEventTracker } from 'mmfintech-checkout-commons'

export const DepositResult = ({ session, sessionId, response }) => {
  const { result, resultType, processingAmount, status } = response || {}

  const history = useHistory()

  const { trackEvent } = useEventTracker()

  if (status === 'FAILED') {
    history.push('/fail')
    return
  }

  const redirectToProvider = () => {
    trackEvent(sessionId, 'redirected_to_provider')
    redirectToExternalUrl(result)
  }

  switch (resultType) {
    // case 'INSTRUCTIONS':
    // case 'INTERNAL_EXECUTION':
    // case 'CRYPTO_ADDRESS_DETAILS':

    case 'MESSAGE':
      return <PreviewMessage result={result} />

    case 'REDIRECT_URL':
      redirectToProvider()
      break

    case 'BANKWIRE_DETAILS':
      return <PreviewBankwire result={result} session={session} sessionId={sessionId} />

    case 'QR_CODE':
      return <PreviewPix value={result} />

    case 'CHECKOUT_CRYPTO_ADDRESS_DETAILS':
      return <PreviewCrypto sessionId={sessionId} data={{ ...result, ...{ processingAmount } }} />

    case 'IFRAME_URL':
      if (isMobileDevice()) {
        redirectToProvider()
      } else {
        trackEvent(sessionId, 'open_provider_in_frame')
        return <PreviewFrame url={result} />
      }
      break

    default:
      if (!isProduction && resultType) {
        console.log(`DepositResult: Unknown result type "${resultType}"`)
      }
  }

  if (status === 'PROCESSED') {
    history.push('/success')
  }

  return null
}
